import styled, { css } from 'styled-components';
import React, { useState, useCallback } from 'react';
import { Button } from '../Button';
import indents from '../../constants/js/indents.js';
import borders from '../../constants/js/border.js';
import colors from '../../constants/js/colors.js';
import text from '../../constants/js/text.js';
import IconWrapper from '../../core/IconWrapper';
import IconAttention from '@bankiru/icons/react/AttentionFilled16';
import IconDanger from '@bankiru/icons/react/DangerFilled16';
import IconCheckmark from '@bankiru/icons/react/CheckmarkFilled16';
import IconSecurity from '@bankiru/icons/react/Security16';
import IconCloseMedium from '@bankiru/icons/react/Close16';
import IconCloseSmall from '@bankiru/icons/react/CloseSmall16';
var colorIcons;

(function (colorIcons) {
  colorIcons["warning"] = "majorOrange";
  colorIcons["error"] = "majorRed";
  colorIcons["info"] = "majorBlue";
  colorIcons["success"] = "majorGreen";
  colorIcons["security"] = "majorGreen";
})(colorIcons || (colorIcons = {}));

var backgroundColorThemes;

(function (backgroundColorThemes) {
  backgroundColorThemes["warning"] = "minorYellow50";
  backgroundColorThemes["error"] = "minorRed10";
  backgroundColorThemes["info"] = "minorBlueLighten";
  backgroundColorThemes["success"] = "greenLight";
  backgroundColorThemes["security"] = "majorWhite";
})(backgroundColorThemes || (backgroundColorThemes = {}));

var colorThemes;

(function (colorThemes) {
  colorThemes["warning"] = "minorYellow50";
  colorThemes["error"] = "minorRed10";
  colorThemes["info"] = "minorBlueLighten";
  colorThemes["success"] = "greenLight";
  colorThemes["security"] = "green100";
})(colorThemes || (colorThemes = {}));

var borderStyles;

(function (borderStyles) {
  borderStyles["warning"] = "solid";
  borderStyles["error"] = "solid";
  borderStyles["info"] = "solid";
  borderStyles["success"] = "solid";
  borderStyles["security"] = "dashed";
})(borderStyles || (borderStyles = {}));

var buttonStyles;

(function (buttonStyles) {
  buttonStyles["warning"] = "orange";
  buttonStyles["error"] = "red";
  buttonStyles["info"] = "blue";
  buttonStyles["success"] = "green";
  buttonStyles["security"] = "green";
})(buttonStyles || (buttonStyles = {}));

const getIcon = name => {
  switch (name) {
    case 'warning':
      return React.createElement(IconAttention, null);

    case 'error':
      return React.createElement(IconDanger, null);

    case 'info':
      return React.createElement(IconDanger, null);

    case 'success':
      return React.createElement(IconCheckmark, null);

    case 'security':
      return React.createElement(IconSecurity, null);
  }
};

const StyledAlertContainer = styled.div.withConfig({
  componentId: "Alert__sc-1chsw1h-0"
})(["padding:", ";display:flex;align-items:center;width:100%;box-sizing:border-box;border-radius:", ";opacity:", ";transition:opacity 0.2s ease-out;", ""], ({
  size
}) => size === 'small' ? indents.indent12 : indents.indentS, borders.borderRadius, ({
  isOpened
}) => {
  return isOpened ? 1 : 0;
}, ({
  type
}) => css(["background-color:", ";border:1px ", " ", ";"], colors[backgroundColorThemes[type]], borderStyles[type], colors[colorThemes[type]]));
const StyledIconContainer = styled.span.withConfig({
  componentId: "Alert__sc-1chsw1h-1"
})(["display:inline-flex;", ""], ({
  type
}) => css(["color:", ";"], colors[colorIcons[type]]));
const StyledContent = styled.div.withConfig({
  componentId: "Alert__sc-1chsw1h-2"
})(["font-weight:", ";margin-right:", ";", ""], text.textWeightRegular, indents.indentS, ({
  size
}) => size === 'small' ? css(["font-size:", ";line-height:", ";margin-left:", ";"], text.fontSize7, text.lineHeight7, indents.indentXS) : css(["font-size:", ";line-height:", ";margin-left:", ";"], text.fontSize6, text.lineHeight6, indents.indent12));
const StyledCloseContainer = styled.span.withConfig({
  componentId: "Alert__sc-1chsw1h-3"
})(["margin-left:auto;opacity:0.7;transition:opacity 0.2s ease-out;cursor:pointer;color:", ";display:inline-flex;&:hover,&:focus{color:", ";opacity:1;}"], colors.grayTrans2, colors.minorDarkBlue);
const StyledButtonContainer = styled.div.withConfig({
  componentId: "Alert__sc-1chsw1h-4"
})(["margin-top:", ";"], indents.indentXS);
export const Alert = props => {
  const [isOpened, setOpenState] = useState(true);
  const {
    type,
    content,
    size,
    onClose,
    buttonContent,
    onClickButton
  } = props;
  const IconClose = size === 'small' ? IconCloseSmall : IconCloseMedium;
  const isCloseIconShown = type !== 'security';
  const onClick = useCallback(e => onClickButton && onClickButton(e), [onClickButton]);
  return React.createElement(StyledAlertContainer, {
    size: size,
    type: type,
    isOpened: isOpened
  }, React.createElement(StyledIconContainer, {
    size: size,
    type: type
  }, React.createElement(IconWrapper, null, getIcon(type))), React.createElement(StyledContent, {
    size: size
  }, content, buttonContent && React.createElement(StyledButtonContainer, null, React.createElement(Button, {
    size: "h32",
    onClick: onClick,
    skin: buttonStyles[type]
  }, buttonContent))), onClose && isCloseIconShown && React.createElement(StyledCloseContainer, {
    onClick: () => {
      setOpenState(false);
    }
  }, React.createElement(IconWrapper, null, React.createElement(IconClose, null))));
};